/** Sonner portals toasts outside overlays; Radix/Vaul would otherwise treat those clicks as outside-dismiss. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function isSonnerToastInteractionTarget(
	target: EventTarget | null,
): boolean {
	return (
		target instanceof Element &&
		Boolean(target.closest("[data-sonner-toaster], [data-sonner-toast]"))
	);
}
